import { BannerService } from '../banners/banner.service';
import { globalWindow } from '../window-globals';


export function setupNetworkConnectivity(bannerService: BannerService): void {
  window.addEventListener('offline', () => {
    bannerService.addError(new Error('You are currently offline.'));
  });

  window.addEventListener('online', () => bannerService.dismissBanner());

  // Network Information API is only supported in Chromium-based browsers.
  const connection = globalWindow.navigator.connection;
  if (!connection) {
    return;
  }

  let showTimerId: number | undefined;
  let hideTimerId: number | undefined;
  let connectionSpeedWarningVisible = false;

  const showBannerSlowly = (): void => {
    if (hideTimerId !== undefined) {
      window.clearTimeout(hideTimerId);
      hideTimerId = undefined;
    }

    if (connectionSpeedWarningVisible || showTimerId !== undefined) {
      return;
    }

    showTimerId = window.setTimeout(() => {
      showTimerId = undefined;
      connectionSpeedWarningVisible = true;
      bannerService.showSystemBanner({
        content: `We've detected that your internet connection speed is slow. Some features may take longer than expected.`,
        bannerType: 'caution',
      });
    }, 20000);
  };

  const hideBannerSlowly = (): void => {
    if (showTimerId !== undefined) {
      window.clearTimeout(showTimerId);
      showTimerId = undefined;
    }

    if (!connectionSpeedWarningVisible || hideTimerId !== undefined) {
      return;
    }

    hideTimerId = window.setTimeout(() => {
      hideTimerId = undefined;
      connectionSpeedWarningVisible = false;
      // Dismiss slow connection banner if speed improves and remains stable.
      bannerService.resetSystemBanner();
    }, 10000);
  };

  const checkConnectionSpeed = (): void => {
    const effectiveType = connection.effectiveType;
    const slowConnection = !!effectiveType && (effectiveType === '2g' ||
      effectiveType === 'slow-2g' || effectiveType === '3g');

    if (slowConnection) {
      showBannerSlowly();
      return;
    }

    hideBannerSlowly();
  };

  connection.addEventListener('change', () => {
    if (document.visibilityState === 'visible') {
      checkConnectionSpeed();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      window.clearTimeout(showTimerId);
      window.clearTimeout(hideTimerId);
      showTimerId = undefined;
      hideTimerId = undefined;
      checkConnectionSpeed();
    }
  });

  checkConnectionSpeed();
}
